import { useEffect, useState } from "react";
import { Form, NavLink, Outlet, redirect } from "react-router-dom";
import { useAuthStore, User } from "src/components/main/authStore";
import { myAxios, scroll } from "src/components/common/functions";
import appRoutes from "./appRoutes";
import Profile from "../common/profile";
import UserInfoModal from "../common/userInfoModal";
import Modal from "../common/Modal";
import MyCKEditor from "../common/myCKEditor";
import logoutimg from "src/img/logout.png";
import logo from "src/img/logo.png";
import { useUiStore } from "src/components/main/uiStore";
export default function MainLayout(){
    //--------------------------------------------------------------------------------------------
    const setMainMenuStyle = useUiStore(state => state.setMainMenuStyle);
    const mainMenuStyle = useUiStore(state => state.mainMenuStyle);
    const user = useAuthStore(state => state.user) as User;
    const [showUserInfo, setShowUserInfo] = useState(false);
    const [pop, setPop] = useState({ show: false, popName: "", pop: "" });
    const [menuQuery, setMenuQuery] = useState("");
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        const onResize = () => {
            if(window.innerWidth < 960){
                setMainMenuStyle(null);
            }
        }
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    },[setMainMenuStyle]);
    useEffect(() => {
        const handleVisibility = async () => {
            if (document.visibilityState === "visible") {
                // await myAxios({ fileName: "auth/refresh.php" });
            }else if(document.visibilityState === "hidden"){
                
            }
        };
        document.addEventListener("visibilitychange", handleVisibility);
        return () => {
            document.removeEventListener("visibilitychange", handleVisibility);
        };
    }, []);
    useEffect(() => {
        const popName = sessionStorage.getItem("pendingNewspaperPopName") || "";
        const popData = sessionStorage.getItem("pendingNewspaperPopData") || "";
        if (!popName || !popData) return;
        sessionStorage.removeItem("pendingNewspaperPopName");
        sessionStorage.removeItem("pendingNewspaperPopData");
        setPop({
            show: true,
            popName,
            pop: popData,
        });
    }, []);
    if(!user) return <></>;
    const routes = appRoutes(user).filter(r => r.show && (!menuQuery || r.title.toLowerCase().includes(menuQuery.toLowerCase())));
    //---------------------------------------------------------------------------------------------------------------------
    return(
        <>
        <div className = "mainHeader" style = {{background: user.userTheme}}>
            <button type = "button" className = "text-nowrap noButtonStyle" onClick = {() => setShowUserInfo(true)}> 
                <Profile
                    value = {user.profileUrl!}
                    side = {50}
                />
                <span className = "me-2">{user.userName}</span><span className = "fw-bold">V{user.version}</span>
            </button>
            <div className = "greater700" style = {{alignItems: "center" ,display: "flex"}}> 
                <img src = {logo} style = {{height: "50px", display: "block"}} alt = ""/>
                <div className = "ms-2 fs-3">Construct Smarter</div>
            </div>
            <Form method = "post">
                <button type = "submit" className = "text-nowrap noButtonStyle" style = {{background: "inherit", color: "inherit"}}>
                    <img src = {logoutimg} alt = "" className = "me-2"/>
                    <span className = "">Log out</span>
                </button>
            </Form>
        </div>
        <div className = "mainContent">
            <div className = "mainMenu" style = {mainMenuStyle ?? undefined}>
                <div style = {{background: user.userTheme}}>Menu</div>
                <div style = {{padding: "0.5rem"}}>
                    <input
                        className = "form-control"
                        type="text"
                        placeholder="Search modules..."
                        value={menuQuery}
                        onChange={e => setMenuQuery(e.target.value)}
                        style={{width: '100%', padding: '6px', boxSizing: 'border-box'}}
                    />
                </div>
                {routes.length === 0 ? (
                    <div style={{padding: '0.5rem', color: '#666'}}>No modules</div>
                ) : (
                    routes.map((value, index) => (
                        <NavLink
                            key = {index}
                            to = {value.path.split("/")[0]}
                            style = {({ isActive }) => ({
                                backgroundColor: isActive ? "gray" : "",
                                color: isActive ? "white" : ""
                            })}
                            onClick = {() => scroll(null)}
                        >
                            <img src = {value.img} alt = ""/>
                            {value.title}
                        </NavLink>
                    ))
                )}
            </div>
            <div className = "mainComp">
                <Outlet/>
            </div>
        </div>
        {showUserInfo?
            <UserInfoModal
                user = {user}
                closeIt = {() => setShowUserInfo(false)}
                actionKey = "Save"
                editTheme
                editPhoto
            />
        :null}
        {pop.show ? (
            <Modal
                max
                noTopCloseIt
                closeIt = {() => setPop({ show: false, popName: "", pop: "" })}
                title = {pop.popName}
                width = {"900px"}
            >
                <div className = "my-3">
                    <MyCKEditor
                        disabled = {true}
                        data = {pop.pop}
                        onChange = {undefined}
                    />
                </div>
            </Modal>
        ) : null}

        </>
    )
}

export async function logOutAction(){
    useAuthStore.getState().clearToken();
    const res = await myAxios({ fileName: "auth/end.php" });
    if (!res) return;
    throw redirect("/Login");
}

export async function authLoader(){
    const store = useAuthStore.getState();
    let auth = store.isAuthenticated;
    if(!store.isAuthChecked){
        const res = await myAxios({ fileName: "auth/refresh.php" }); // HydrateFallback will apear during this wait.
        store.setAuthChecked(true);
        if(!res){
            store.clearToken();
            store.setAuthenticated(false);
            auth = false;
        }else{
            store.setAuthenticated(true);
            auth = true;
            if (res.data?.popName && res.data?.pop) {
                sessionStorage.setItem("pendingNewspaperPopName", res.data.popName);
                sessionStorage.setItem("pendingNewspaperPopData", res.data.pop);
            }
            store.setUserInfo(res.data?.user ?? res.data);
        }
    }
    if(!auth){
        throw redirect('/Login');
    }else{
        return {};
    }
}
